import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import cross from "../assets/img/cross.svg";
import { addTalkingBadge } from "store/actions/talkingBadgeAction";
import { useDispatch, useSelector } from "react-redux";
import TalkingPreview from "./TalkingPreview";
import { toast } from "react-toastify";
import Paypal from "./Paypal";
import { getTalkingBadge } from "store/actions/talkingBadgeAction";
import { getManagerData } from "store/actions/talkingBadgeAction";

const TalkingBadgeAddModal = ({ toggle, addModal, setBadgeData }) => {
  const dispatch = useDispatch();
  const { user, uid } = useSelector((state) => state.auth);
  const [qrCodePrice, setqrCodePrice] = useState(0);
  const [badgePayment, setBadgePayment] = useState(false);
  const [managerRating, setManagerRating] = useState(false);
  const [formData, setFormData] = useState({
    introducingVideo: null,
    appealingVideo: null,
    amount: qrCodePrice,
    athleteId: user.id,
    athleteID: user.athleteID,
    type: "talkingBadges",
    description: "",
    managerEmail: "",
    managerRating: false,
  });

  const [showCustomPriceInput, setShowCustomPriceInput] = useState(false);
  const [isAddLoading, setIsAddLoading] = useState(false);
  const handleSubmit = async (props) => {
    setIsAddLoading(true);
    let NewData = {
      ...formData,
      isDeleted: false,
    };
    if (props.purchaseID) {
      NewData.purchaseID = props.purchaseID;
      NewData.extra_badge_pay = 0.15;
    }

    if (NewData.managerEmail == "") {
      await dispatch(
        addTalkingBadge(NewData, () => {
          setIsAddLoading(false);
          toggle();
          toast.success("Create Badge Successfully");
          dispatch(getTalkingBadge(uid, "", [], () => {}));
          setqrCodePrice("0");
          setFormData({
            introducingVideo: null,
            appealingVideo: null,
            amount: qrCodePrice,
            athleteId: user.id,
            athleteID: user.athleteID,
            description: "",
            managerEmail: "",
            type: "talkingBadges",
          });
          setShowCustomPriceInput(false);
          setBadgePayment(false);
        })
      );
    } else {
      setIsAddLoading(true);
      await dispatch(
        getManagerData(NewData.managerEmail, async (res) => {
          if (res == "success") {
            await dispatch(
              addTalkingBadge(NewData, () => {
                setIsAddLoading(false);
                toggle();
                toast.success("Create Badge Successfully");
                dispatch(getTalkingBadge(uid, "", [], () => {}));
                setqrCodePrice("0");
                setFormData({
                  introducingVideo: null,
                  appealingVideo: null,
                  amount: qrCodePrice,
                  athleteId: user.id,
                  athleteID: user.athleteID,
                  description: "",
                  managerEmail: "",
                  type: "talkingBadges",
                });
                setShowCustomPriceInput(false);
                setBadgePayment(false);
              })
            );
          } else {
            setIsAddLoading(false);
            toast.error("Manager Does not exist");
          }
        })
      );
    }
  };

  const getPaypalDetail = (details) => {
    let data = {
      purchaseID: details?.id,
    };
    setBadgePayment(false);
    handleSubmit(data);
  };

  const data = {
    athleteImg: user.player_image.url,
    firstName: user?.first_name,
    lastName: user.last_name,
    introducingVideo: formData.introducingVideo,
    appealingVideo: formData.appealingVideo,
    description: formData.description,
  };

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg",
      ];
      if (validImageTypes.includes(file.type)) {
        setFormData((prevData) => ({
          ...prevData,
          [fieldName]: file,
        }));
      } else {
        toast.error("Invalid file type. Please select a valid image file.");
      }
    }
  };

  return (
    <Modal isOpen={addModal} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Create Honor Badge</ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            if (user?.talkingBadge > 50) {
              e.preventDefault();
              if (formData.amount == 0) {
                toast.warning("Please Add Amount");
              } else {
                setBadgePayment(true);
              }
            } else {
              e.preventDefault();
              if (formData.amount == 0) {
                toast.warning("Please Add Amount");
              } else {
                handleSubmit(e);
              }
            }
          }}
        >
          <Row className="d-flex justify-content-center">
            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">Add Description</Label>
                <Input
                  required
                  id="appealingVideo"
                  name="description"
                  type="text"
                  placeholder="Enter Description"
                  value={formData.description}
                  disabled={badgePayment}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 20) {
                      setFormData((prevData) => ({
                        ...prevData,
                        description: inputValue,
                      }));
                    } else {
                      toast.error("Only 20 characters are allowed");
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col className="col-sm-6 col-6">
              <FormGroup>
                <Label for="exampleSelect">Online Badge Card Price</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={qrCodePrice}
                  disabled={badgePayment}
                  onChange={(e) => {
                    setqrCodePrice(e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      amount: e.target.value,
                    }));
                    if (e.target.value === "custom") {
                      setShowCustomPriceInput(true);
                    } else {
                      setShowCustomPriceInput(false);
                    }
                  }}
                >
                  <option value="">--Select Price--</option>
                  <option value="4">4</option>
                  <option value="6">6</option>
                  <option value="8">8</option>
                  <option value="10">10</option>
                  <option value="custom">Custom Value</option>
                </Input>
                {showCustomPriceInput && (
                  <Input
                    required
                    className="mt-2"
                    type="number"
                    placeholder="Enter Custom Value"
                    value={qrCodePrice}
                    onChange={(e) => {
                      setqrCodePrice(e.target.value);
                      setFormData((prevData) => ({
                        ...prevData,
                        amount: e.target.value,
                      }));
                    }}
                    min={17}
                    max={1000}
                    disabled={badgePayment}
                  />
                )}
              </FormGroup>
            </Col>

            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="introducingVideo">
                  QR Code Introduce Self Video
                </Label>
                {formData.introducingVideo && (
                  <div className="position-relative">
                    <img
                      src={URL.createObjectURL(formData.introducingVideo)}
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />
                    {!badgePayment && (
                      <img
                        src={cross}
                        width={20}
                        alt=""
                        className="position-absolute"
                        required
                        style={{
                          top: "-11%",
                          left: "39%",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            introducingVideo: null,
                          }))
                        }
                      />
                    )}
                  </div>
                )}
                {!formData.introducingVideo && (
                  <Input
                    required
                    id="introducingVideo"
                    name="introducingVideo"
                    type="file"
                    accept=".jpg, .jpeg, .svg, .png"
                    onChange={(e) => handleImageChange(e, "introducingVideo")}
                  />
                )}
              </FormGroup>
            </Col>

            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">QR Code Entertainment Video</Label>
                {formData.appealingVideo && (
                  <div className="position-relative">
                    <img
                      src={URL.createObjectURL(formData.appealingVideo)}
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />
                    {!badgePayment && (
                      <img
                        src={cross}
                        width={20}
                        alt=""
                        className="position-absolute"
                        required
                        style={{
                          top: "-11%",
                          left: "39%",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            appealingVideo: null,
                          }))
                        }
                      />
                    )}
                  </div>
                )}
                {!formData.appealingVideo && (
                  <Input
                    required
                    id="appealingVideo"
                    name="appealingVideo"
                    type="file"
                    accept=".jpg, .jpeg, .svg, .png"
                    onChange={(e) => handleImageChange(e, "appealingVideo")}
                  />
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col className="col-sm-6 col-6 mt-3">
              <Label for="exampleSelect">Manager Email</Label>
              <Input
                name="Email"
                type="email"
                placeholder="Enter Manager Email"
                value={formData.managerEmail}
                disabled={badgePayment}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  setFormData((prevData) => ({
                    ...prevData,
                    managerEmail: inputValue,
                  }));
                }}
              />
            </Col>
            <Col className="col-sm-6 col-6 mt-5">
              <Button color="primary" type="submit" disabled={isAddLoading}>
                {isAddLoading ? <Spinner size="sm" /> : "Create Badge"}
              </Button>
            </Col>
          </Row>
          {badgePayment && (
            <>
              <h5 className="text-center text-danger my-2">
                You have reached your limit of free posts, pay $0.15 to continue
              </h5>
              <div>
                <Paypal price={0.15} getPaypalDetail={getPaypalDetail} />
              </div>
            </>
          )}
        </Form>
        <Row className="d-flex justify-content-center">
          <Card className="col-lg-6 col-md-8 col-sm-8 mb-3 mt-5 mx-2">
            <TalkingPreview data={data} />
          </Card>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default TalkingBadgeAddModal;
